import { modalRoute } from '@/router/helpers/modalRoute'

export const beneficiaryRoutes = [
  {
    path: 'beneficiary',
    name: 'Beneficiaries',
    component: () => import('@/components/beneficiaries/List.vue'),
    children: [
      modalRoute(
        'add',
        'AddBeneficiary',
        () => import('@/components/beneficiaries/modals/Add.vue'),
      ),
      modalRoute(
        'view/:beneficiaryId',
        'ViewBeneficiary',
        () => import('@/components/beneficiaries/modals/View.vue'),
      ),
      modalRoute(
        'view/:beneficiaryId/edit',
        'EditBeneficiary',
        () => import('@/components/beneficiaries/modals/Edit.vue'),
        {
          alias: 'edit/:beneficiaryId',
        },
      ),
      modalRoute(
        'view/:beneficiaryId/delete',
        'DeleteBeneficiary',
        () => import('@/components/beneficiaries/modals/Delete.vue'),
        {
          alias: 'delete/:beneficiaryId',
          meta: {
            permissions: ['beneficiaryDelete'],
          },
        },
      ),
      modalRoute(
        'transfer/:beneficiaryId?',
        'TransferFromBeneficiary',
        () => import('@/components/wallets/modals/transfer/Transfer.vue'),
      ),
    ],
  },
]
